import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useNavigate } from "react-router-dom";
import { handleOnClickLogout, getAllCards } from "../constants";
import {
  NavBar,
  SideBar,
  Breadcrumb,
  Cards,
  AddCard,
  UpdateCard,
} from "../components";
import "intro.js/introjs.css";
import introJs from "intro.js";

const Home = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const mission = JSON.parse(localStorage.getItem("mission"));
  const [missi, setMissi] = useState(mission);
  const token = user.access_token;
  const [cards_, setCards] = useState([]);
  const [cardData, setCardData] = useState({});
  const [breads, setBreads] = useState(["Cards"]);
  const [loading, setLoading] = useState(false);
  const [innerHTML, setInnerHTML] = useState("");

  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };

  useEffect(() => {
    getAllCards(token, setCards);
    if (mission && mission.create_card == true && mission.share_card == false) {
      introJs()
        .setOptions({
          steps: [
            {
              title: `Continue to Sharing`,
              intro: "Now let’s move on to the second part: sharing your card",
            },
            {
              title: "Share URL",
              element: document.querySelector("#dropDownShare"),
              intro:
                "Click Share button, copy, and share your card’s unique link (URL).",
            },
            {
              title: "Share QR",
              element: document.querySelector("#cardQR"),
              intro: "Download or scan your card’s QR code for easy sharing.",
            },

            {
              title: "Share with an Introduction Message",
              element: document.querySelector("#shareMsg"),
              intro:
                "Send your card along with a personalized message to make it more engaging.",
            },
          ],
          showBullets: true,
          tooltipClass: "font-nitomeyocard",
        })
        .start();
    }
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      {innerHTML ? (
        <div
          className="flex flex-col bg-red-700 text-white w-full py-3 text-center"
          dangerouslySetInnerHTML={{ __html: innerHTML }}
        ></div>
      ) : null}

      <div className="flex flex-row w-full h-full">
        <SideBar active={breads[0].toLocaleLowerCase()} mission_={missi} />
        <div className="flex flex-col w-full bg-red-100">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            {breads[breads.length - 1] == "Cards" ? (
              <Cards cards={cards_} mission={mission} setMission={setMissi} />
            ) : (
              <UpdateCard data={cardData} />
            )}
          </div>
        </div>
        {/* <button */}
        {/*   onClick={() => { */}
        {/*     throw new Error("This is your first error!"); */}
        {/*   }} */}
        {/* > */}
        {/*   Break the world */}
        {/* </button> */}
      </div>
    </div>
  );
};

export default Home;
